// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getTag } from 'selectors';

class RecommendationProgramInfo extends Component {
  render() {
    const {
      recommendation,
      recommendation: { program },
      university,
    } = this.props;

    return (
      <div className="RecommendationProgramInfo">
        <h3 className="RecommendationProgramInfo-name">{program.name}</h3>
        {recommendation.sponsored && (
          <span className="RecommendationProgramInfo-sponsored">Sponsored</span>
        )}
        <h4 className="RecommendationProgramInfo-uni-name">
          {university.name}
        </h4>
      </div>
    );
  }
}

RecommendationProgramInfo.propTypes = {
  recommendation: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const university = getTag(state, props.recommendation.program.university);
  return {
    university,
  };
}

export default connect(mapStateToProps)(RecommendationProgramInfo);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationProgramInfo.js